<template>
    <component :is="activityTypeWrapper" :item="item" style="line-height: 1.1" />
</template>
<script setup>
import DefaultActivityType from './ActivityTypes/DefaultActivityType.vue';
import AssetLocationChanged from './ActivityTypes/AssetLocationChanged.vue';
import AssetOperabilityChanged from './ActivityTypes/AssetOperabilityChanged.vue';
import AssetUsageCategoryChanged from './ActivityTypes/AssetUsageCategoryChanged.vue';
import PerformanceDataEntry from './ActivityTypes/PerformanceDataEntry.vue';
import AssetDeleted from './ActivityTypes/AssetDeleted.vue';
import Stakeholder from './ActivityTypes/Stakeholder.vue';
import AssetStakeholdersChanged from './ActivityTypes/AssetStakeholdersChanged.vue';
import ExportCreated from './ActivityTypes/ExportCreated.vue';
import TaskResolved from './ActivityTypes/TaskResolved.vue';
import { computed } from 'vue';
import TaskDeleted from '@/Components/ActivityLog/ActivityTypes/TaskDeleted.vue';
import QualityAssuranceConfiguration from '@/Components/ActivityLog/ActivityTypes/QualityAssuranceConfiguration.vue';
import TaskApproved from '@/Components/ActivityLog/ActivityTypes/TaskApproved.vue';

const props = defineProps({ item: Object });
const templates = {
    default: DefaultActivityType,
    'task.approved': TaskApproved,
    'task.deleted': TaskDeleted,
    'task.resolved': TaskResolved,
    'asset.location.changed': AssetLocationChanged,
    'asset.operability.changed': AssetOperabilityChanged,
    'asset.usage-category.changed': AssetUsageCategoryChanged,
    'asset.deleted': AssetDeleted,
    'export.created': ExportCreated,
    owner: Stakeholder,
    maintainer: Stakeholder,
    operator: Stakeholder,
    'performance-data': PerformanceDataEntry,
    'asset.stakeholders.changed': AssetStakeholdersChanged,
    quality_assurance_configuration: QualityAssuranceConfiguration,
};

const activityTypeWrapper = computed(() => {
    // Try exact match
    if (templates[props.item.event]) {
        return templates[props.item.event];
    }

    let prefix = props.item.event.split('.')[0];
    if (templates[prefix]) {
        return templates[prefix];
    }

    return templates.default;
});
</script>
